import {
  Wrench,
  Car,
  DollarSign,
  MapPinHouse,
  CalendarCheck,
} from "lucide-react";
import { Footer, ServiceCard } from "../components/index.ts";
import SprayGunIcon from "../assets/icons/spray-gun.svg?react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { HomeStructuredData } from "./structuredData.ts";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>
          GabyLen Autoservice & ITP Florești - Reparații Auto, ITP, Tinichigerie
          & Vopsitorie
        </title>
        <meta
          name="description"
          content="Descoperă GabyLen Autoservice & ITP din Florești! Oferim reparații auto, inspecție ITP, Tinichigerie & Vopsitorie, schimb cauciucuri și multe alte servicii auto de calitate."
        />
        <meta
          name="keywords"
          content="service auto Florești, GabyLen Autoservice, reparații auto Florești Cluj, inspecție ITP Florești, schimb cauciucuri Florești, reparații caroserie Florești, mecanică auto Cluj, ITP Florești Cluj"
        />
        <script type="application/ld+json">
          {JSON.stringify(HomeStructuredData)}
        </script>
      </Helmet>
      <div className="relative bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                GabyLen Auto Service
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                GabyLen Auto Service este un atelier profesionist de reparații
                auto care deservește clienții din 2012. Echipa noastră este
                dedicată furnizării de servicii de top în reparații de
                caroserie, tinichigerie & vopsitorie, mecanică & ITP. Credem că
                mașina dumneavoastră merită cea mai bună îngrijire și asta
                promitem să oferim.
              </p>
              <Link
                to="/itp"
                className="bg-red-600 text-white px-8 py-3 rounded-md text-lg hover:bg-red-700"
                aria-label="Rezervă inspecția tehnică periodică acum"
              >
                Rezervă ITP acum
              </Link>
            </div>
            <div className="hidden md:block">
              <img
                src="https://ik.imagekit.io/gabylenautoservice/cover-thumbnail.jpg?updatedAt=1739042844257"
                alt="Locatie service GabyLen"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Serviciile noastre
            </h2>
            <p className="text-gray-600">
              GabyLen Auto Service este un atelier profesionist de reparații
              auto care deservește clienții din 2012. Echipa noastră este
              dedicată furnizării de servicii de top în reparații de caroserie,
              tinichigerie & vopsitorie, mecanică & ITP. Credem că mașina
              dumneavoastră merită cea mai bună îngrijire și asta promitem să
              oferim.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ServiceCard
              renderedIcon={
                <SprayGunIcon className={"text-red-600 w-6 h-6"} />
              }
              title="Tinichigerie & Vopsitorie"
              description="Avem o echipă experimentată, specializată în reparația oricărui tip de daună."
            />
            <ServiceCard
              Icon={Wrench}
              title="Mecanică & Revizii periodice"
              description="Folosim echipamente de diagnoză de ultimă oră și oferim de la servicii simple de mentenanță, până la lucrări complexe."
            />
            <ServiceCard
              Icon={CalendarCheck}
              title="ITP"
              description="Asigurăm inspecții ITP într-o stație modernă construită în 2024."
            />
          </div>
        </div>
      </div>
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <div className="text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                De ce noi?
              </h2>
            </div>
            <p className="text-gray-600">
              GabyLen Auto Service este un service de reparații auto cu servicii
              complete începând cu anul 2012. Echipa noastră de profesioniști și
              tehnicieni cu experiență este dedicată să ofere servicii și
              reparații de înaltă calitate pentru a vă menține vehiculul într-o
              stare de funcționare impecabilă. Indiferent dacă aveți nevoie de
              reparații de caroserie, vopsitorie, mecanică sau ITP, la noi
              găsiți tot ce aveți nevoie. Ne mândrim cu munca noastră și ne
              străduim să depășim așteptările dumneavoastră cu fiecare vizită.
              Contactați-ne astăzi pentru a vă face o programare.
            </p>
            <br />
            <p className="text-gray-600">
              Colaborăm cu toate companiile de asigurări, efectuăm reparații
              daune RCA oferind <span className="font-bold">GRATUIT</span>{" "}
              mașina de schimb pe toată durata reparației. Fiind parteneri
              Groupama, oferim în exclusivitate reparații CASCO pentru cei
              asigurați la această companie.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-16">
            <div className="text-center md:text-left">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPinHouse className="text-red-600" size={24} />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-center">
                Orar și locație
              </h3>
              <p className="text-gray-600">
                Amplasați aproape de mijlocul comunei Florești, str. Porii 162
                (în capăt strada), suntem doar la o aruncătură de băț de
                dumneavoastră. Știm că timpul e important de aceea vă așteptam
                în intervalul 9-17.
              </p>
            </div>
            <div className="text-center md:text-left">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <DollarSign className="text-red-600" size={24} />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-center">
                Prețuri corecte
              </h3>
              <p className="text-gray-600">
                Credem că toată lumea merită servicii de reparații auto de
                înaltă calitate la un preț accesibil, fără a compromite
                calitatea muncii noastre.
              </p>
            </div>
            <div className="text-center md:text-left">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Car className="text-red-600" size={24} />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-center">
                Calitatea
              </h3>
              <p className="text-gray-600">
                Echipa noastră de profesioniști este pregătită pentru a face
                față oricăror nevoi de reparații auto pe care le aveți.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
